// @core/api/endpoints/project/add_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddItemRequest,
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Add item to project
 * Adds an existing task from a product's TaskService to this project, creating a ProjectItem wrapper with project-specific metadata like story points and column assignment.
 */
export async function AddItem(
  project_id: string,
  data: AddItemRequest,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/items`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<ItemResponse>(requestPath, data, requestOptions);
}
